/* Bespoke CSS reserved for what Astryx components can't express: the
   hover/focus scope for the delete reveal, and a per-child flex property
   (the field grows, the delete control doesn't). Mirrors the same idiom in
   QuestionCard.module.css so section and question cards read as siblings. */

.card {
  /* Establishes the hover/focus scope for the delete control below —
     hovering anywhere in the card's padded area reveals it. */
  position: relative;
}

.body {
  flex: 1;
  min-width: 0;
}

.delete {
  flex-shrink: 0;
  margin-top: var(--spacing-1);
  opacity: 0;
  transition: opacity var(--duration-fast) var(--easing-default);
}

.card:hover .delete,
.card:focus-within .delete {
  opacity: 1;
}

@media (prefers-reduced-motion: reduce) {
  .delete {
    transition: none;
  }
}

/* Entrance animation for a just-inserted section (see `isEntering` on
   SectionCardProps) — same grid-row grow trick as QuestionCard.module.css
   (kept file-local rather than shared, since CSS Modules keyframe names are
   scoped per file and cross-file sharing isn't worth the coupling for ~15
   lines of CSS). No highlight ring — grow + fade + slight translateY only. */
.enterWrapper {
  display: grid;
  grid-template-rows: 0fr;
  animation: sectionCardGrowIn 220ms ease-out forwards;
}

.enterWrapper > .card {
  overflow: hidden;
}

@keyframes sectionCardGrowIn {
  from {
    grid-template-rows: 0fr;
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    grid-template-rows: 1fr;
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .enterWrapper {
    animation: none;
    grid-template-rows: 1fr;
  }

  .enterWrapper > .card {
    overflow: visible;
  }
}
